import { Typography } from "antd";
import { intro, lastUpdated, legalTitle, sectionBody, sectionHeading } from "../LegalPage.styles.ts";

const { Title, Paragraph, Text } = Typography;

export const ImpressumEn = () => (
  <article>
    <Title className={legalTitle} level={1}>
      Legal notice
    </Title>
    <Text className={lastUpdated}>Information pursuant to Art. 4 of the Bulgarian Electronic Commerce Act</Text>

    <Paragraph className={intro}>
      The information below identifies the operator of the Calculabel service (calculabel.com and related domains) and
      is provided to comply with the disclosure obligations under the Bulgarian Electronic Commerce Act (Закон за
      електронната търговия) and the EU E-Commerce Directive (2000/31/EC).
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      Company details
    </Title>
    <div className={sectionBody}>
      <ul>
        <li>
          <strong>Name:</strong> Фууд Сейфти Консултинг ЕООД (Food Safety Consulting EOOD)
        </li>
        <li>
          <strong>Legal form:</strong> Bulgarian sole-owner limited liability company (ЕООД)
        </li>
        <li>
          <strong>Company registration number (ЕИК / UIC):</strong> 204435984
        </li>
        <li>
          <strong>VAT number (ДДС №):</strong> BG204435984
        </li>
        <li>
          <strong>Registered address:</strong> ул. Тракия № 34, 1527 София, България
        </li>
        <li>
          <strong>Trade register:</strong> Търговски регистър at the Агенция по вписванията of the Republic of Bulgaria
        </li>
      </ul>
    </div>

    <Title className={sectionHeading} level={4}>
      Contact
    </Title>
    <div className={sectionBody}>
      <ul>
        <li>
          <strong>Email:</strong> <a href="mailto:support@calculabel.com">support@calculabel.com</a>
        </li>
        <li>
          <strong>Website:</strong> <a href="https://calculabel.com">calculabel.com</a>
        </li>
      </ul>
    </div>

    <Title className={sectionHeading} level={4}>
      Activity
    </Title>
    <Paragraph className={sectionBody}>
      Operation of the Calculabel software-as-a-service platform — recipe and ingredient management, nutrition
      calculation, food and wine label generation, QR-code labels, purchase tracking, and meal planning.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      Online dispute resolution
    </Title>
    <Paragraph className={sectionBody}>
      In accordance with Regulation (EU) No 524/2013, the European Commission provides an Online Dispute Resolution
      platform: <a href="https://ec.europa.eu/consumers/odr">ec.europa.eu/consumers/odr</a>. We are not obliged to and
      do not commit in advance to participate in alternative dispute resolution before a consumer arbitration body.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      Supervisory authority for personal data
    </Title>
    <Paragraph className={sectionBody}>
      Комисия за защита на личните данни (КЗЛД)
      <br />
      бул. „Проф. Цветан Лазаров“ № 2, 1592 София, България
      <br />
      <a href="https://www.cpdp.bg">www.cpdp.bg</a>
    </Paragraph>
  </article>
);
